import { render } from "./ArticleItem.vue?vue&type=template&id=d37f9502"
import script from "./ArticleItem.vue?vue&type=script&lang=js"
export * from "./ArticleItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__